var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"daily-by-code-export-page-container"},[_c('div',{attrs:{"id":"viewer2","dir":"ltr"}})])
}]

export { render, staticRenderFns }